import { ArrowUpRight } from "lucide-react";
import { ORDER_URL } from "@/data/menu";
import { Reveal } from "@/components/Reveal";

export const FinalCTA = () => (
  <section id="order" data-testid="final-cta-section" className="bg-brand-dark py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <Reveal>
        <h2 className="max-w-3xl font-serif text-3xl font-light leading-snug tracking-tight text-white md:text-5xl">
          ГОТОВИ ЗА ВАШЕТО ПАРТИ?
        </h2>
        <div className="mt-8 max-w-2xl space-y-4 text-sm font-light leading-relaxed text-white/75 md:text-base">
          <p>
            Избраната PARTY комбинация, допълнителните плата и сладките
            предложения се заявяват директно към екипа на Детски парти клуб
            „Българче“, заедно с останалите детайли по вашето парти.
          </p>
          <p>Така цялата информация за събитието, броя гости и храната остава на едно място.</p>
          <p>
            Детски парти клуб „Българче“ приема вашата заявка, а „B1 &amp; B2“
            приготвя и доставя избраните кетъринг предложения.
          </p>
        </div>
        <a
          href={ORDER_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cta-final-order"
          className="mt-12 inline-flex items-center gap-2 rounded-full bg-brand-accent px-10 py-5 text-sm font-semibold uppercase tracking-wide text-white transition hover:bg-brand-accentHover active:scale-[0.98] md:text-base"
        >
          Заявете към „Българче“
          <ArrowUpRight className="h-5 w-5" aria-hidden="true" />
        </a>
      </Reveal>
    </div>
  </section>
);
